import {
  GetUnhandledQualifiedInvoiceIssueRequestsQuery,
  gqlClient,
  gqlHeader,
  runGqlQueryV2,
} from "@graffer-inc/smart-apply";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";

type Props = {
  orgId: string;
};

export const QualifiedInvoiceIssueRequestsContainerHooks = ({
  orgId,
}: Props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [issueRequests, setIssueRequests] = useState<
    GetUnhandledQualifiedInvoiceIssueRequestsQuery["unhandledQualifiedInvoiceIssueRequests"]
  >([]);

  const onFetch = async () => {
    setIsLoading(true);
    try {
      const res = await runGqlQueryV2(() =>
        gqlClient.getUnhandledQualifiedInvoiceIssueRequests(
          {
            orgId,
          },
          gqlHeader("q"),
        ),
      );
      if (res.error) {
        throw res.error;
      }
      if (res.data?.unhandledQualifiedInvoiceIssueRequests) {
        setIssueRequests(res.data.unhandledQualifiedInvoiceIssueRequests);
      }
    } catch (e) {
      toast.error(
        "未対応の交付依頼一覧の取得に失敗しました。時間をおいてから、再度お試しください。",
      );
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (orgId) onFetch();
  }, []);

  return {
    isLoading,
    issueRequests,
  };
};
